import React from 'react';
import { Link, ListItem, UnorderedList } from '@piggybank/core';
import { Translation } from 'srcAlias/client/locale';
import translations from 'contentAlias';

export const DeclarationContent = (path) => {
  return (
    <>
      <UnorderedList type={'none'}>
        {path &&
          path.path.map((contentItem, index) => (
            <ListItem key={index}>
              {typeof contentItem[index] === 'object' ? (
                <>
                  {contentItem[index].heading}
                  <UnorderedList type={'none'}>
                    {contentItem[index].listContent.map((item, i) => (
                      <ListItem key={i}>
                        {typeof item[i] === 'object' ? (
                          <>
                            {item[i].content.firstHalf}
                            <Link href={item[i].content.linkUrl} external>
                              {item[i].content.linkUrl}
                            </Link>
                            {item[i].content.secondHalf}
                          </>
                        ) : (
                          item[i]
                        )}
                      </ListItem>
                    ))}
                  </UnorderedList>
                </>
              ) : (
                contentItem[index]
              )}
            </ListItem>
          ))}
      </UnorderedList>
    </>
  );
};

export const ClientClosureDisclosureStatement = () => {
  return (
    <div>
      <Link
        href="https://www.hsbc.com.sg/content/dam/hsbc/sg/documents/wealth/investments/best-execution-client-disclosure-statement.pdf"
        external
        textMap={{
          newWindow: (
            <Translation path="clientClosureDisclosureStatement.textMap" />
          ),
        }}
        name="clientClosureDisclosureStatementLink"
      >
        <Translation path="clientClosureDisclosureStatement.linkText" />
      </Link>
    </div>
  );
};

export const CrossBorderDisclosureStatement = () => {
  return (
    <div>
      <Link
        href={translations.customer.declaration.crossBorderDisclosure.linkUrl}
        external
        textMap={{
          newWindow: <Translation path="crossBorderDisclosure.textMap" />,
        }}
        name="crossBorderDisclosureLink"
      >
        <Translation path="crossBorderDisclosure.linkText" />
      </Link>
    </div>
  );
};
